declare global {
  interface Window {
    __LC_DEBUG_ENABLED__?: boolean;
    __LC_PERF_COUNTS__?: Record<string, number>;
  }
}

export function isRuntimeDebugEnabled() {
  if (typeof window === "undefined") return false;
  return window.__LC_DEBUG_ENABLED__ === true;
}

export function recordProTableDiagnostic(
  name: string,
  detail?: Record<string, unknown>,
) {
  if (typeof window === "undefined" || !isRuntimeDebugEnabled()) return;
  if (!window.__LC_PERF_COUNTS__) {
    window.__LC_PERF_COUNTS__ = {};
  }
  const eventName = String(name || "").trim();
  if (!eventName) return;
  const nextCount = Number(window.__LC_PERF_COUNTS__[eventName] || 0) + 1;
  window.__LC_PERF_COUNTS__[eventName] = nextCount;
  console.info("[LC PERF]", {
    name: eventName,
    count: nextCount,
    detail,
  });
}

export function resolveProTableQueryActionName(
  text: string,
): "query" | "reset" | undefined {
  const normalized = String(text || "").replace(/\s+/g, "");
  if (normalized === "查询") return "query";
  if (normalized === "重置") return "reset";
  return undefined;
}

export function buildProTableQueryDelayDetail(
  capturedAt: number,
  triggeredAt: number,
) {
  return {
    delayMs: Math.round(triggeredAt - capturedAt),
  };
}

function getDiagnosticValueType(value: unknown): string {
  if (Array.isArray(value)) return `array(${value.length})`;
  if (value === null) return "null";
  return typeof value;
}

export function buildProTableRequestParamsSummary(
  params: Record<string, unknown>,
) {
  const keys = Object.keys(params || {});
  return {
    keys,
    fieldTypes: keys.reduce<Record<string, string>>((acc, key) => {
      acc[key] = getDiagnosticValueType(params[key]);
      return acc;
    }, {}),
  };
}

export function shouldRecordProTableLongTask(duration: number) {
  return Number(duration || 0) >= 50;
}

export function getNowTime() {
  return typeof performance !== "undefined" ? performance.now() : Date.now();
}
